import React, { useEffect } from "react";
import { useGetAnalystsVotesSpreadQuery } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";
import TableLayout from "../../../../components/layout/TableLayout";

const VotesSpread = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);

    useEffect(() => {
        setRequiredFilters(['analyst'])
    }, [setRequiredFilters])

    const validFilters = {
        ...appliedFilters,
        initialDateRange: dateRange,
    }

    return (
        <TableLayout>
            <PaginatedDataTable
                queryHook={useGetAnalystsVotesSpreadQuery}
                initialDateRange={dateRange}
                totalText="All Report Total"
                isColumnSticky={true}
                stickyColumnsCount={2}
                appliedFilters={validFilters}
            />
        </TableLayout>
    );
};

export default VotesSpread;
